export const DELETE_RESOURCE_SECTION = gql`
    mutation deleteResourceSection($input: DeleteResourceInput!) {
        deleteResourceSection(input: $input) {
            status
        }
    }
`;
